<template>
	<div>
		<div class="main-header">
			<div class="container">
				<h2 class="main-header-text">Reset Password</h2>
			</div>
		</div>
		<!-- eo main header -->
		<div class="main-section mgt-40">
			<div class="container">

				<div class="main-card">
					<img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />
					<div class="tac">
						<div class="login-box">
							<div class="login-form" style="border:0">
								<form @submit.prevent="onSubmit" novalidate="" autocomplete="off">
									<div class="form-group">
										<label for="">
											Password <span class="required">*</span>
										</label>
										<div>
											<password-input :inputplaceholder="Password" autocomplete="off"
																			v-model="vModel.Password" v-validate="{required : true,validatePassword : true}"
																			:inputname="'UserPassword'" name="UserPassword"
																			:inputclass="{'form-control input': true, 'is-danger': errors.has('UserPassword') }"></password-input>
										</div>
										<div v-show="errors.has('UserPassword')"
												 class="help is-danger">
											{{ errors.first('UserPassword') }}
										</div>
									</div>

									<div class="form-group">
										<label for="">
											Confirm Password <span class="required">*</span>
										</label>
										<input autocomplete="off" placeholder="Confirm Password" :disabled="!vModel.Password"
													 v-model="vModel.ConfirmPassword"
													 v-validate="'required|confirmed:UserPassword'"
													 :class="{'input': true, 'is-danger': errors.has('Password_Confirmation') }"
													 type="password" class="form-control"
													 data-vv-name="Password_Confirmation" data-vv-as="Password" />

										<div v-show="errors.has('Password_Confirmation')" class="help is-danger">{{ errors.first('Password_Confirmation') }}</div>
									</div>
									<button class="btn main-btn">Reset</button>
								</form>


								<router-link :to="'/account/login'" class="forgot-password">Sign In</router-link>
							</div>
							<!-- eo login-form -->
						</div>
					</div>

				</div>
				<!-- eo main card -->

			</div>
			<!-- eo container -->
		</div>
		<!-- eo main section -->

	</div>
</template>
<script>
	import authservice from "../../services/authservice";
	import welcome from '../../shared/Welcome.vue'
	import PasswordInput from "../../shared/PasswordInput";
	import commonService from "../../services/common";


	export default {
		name: "login",
		components: {
			welcome,
			PasswordInput,
		},
		data() {
			return {
				vModel: {
					Code: null,
					UserId: null,
					Password: null,
					ConfirmPassword: null
				}
			};
		},
		beforeRouteEnter(to, from, next) {
			next(p => {
				p.vModel.Code = decodeURI(to.query.code)
				p.vModel.UserId = decodeURI(to.query.userid)
			});
		},
		methods: {
			onSubmit() {
				this.$validator.validateAll().then(result => {
					if (result) {

						this.$http.post('account/resetpassword', {
							UserId: this.vModel.UserId,
							Code: this.vModel.Code,
							NewPassword: this.vModel.Password,
							ConfirmPassword: this.vModel.ConfirmPassword,
						}).then(response => {

							this.$toastr("success", "Password reset successfully.");
							
							if(commonService.getStorage('forget-password-show-dob')){							
							commonService.removeStorage('forget-password-show-dob');
							}

							setTimeout(() => {
								window.Vue.$router.push('/account/login');
							}, 500);

						}, response => {

						});
					}
				});
			}
		}
	};
</script>
